import { useState } from "react";
import { IDP } from "@maxeb/idp-sdk";
export default function useAuthenticator() {
    const state = {
        state: "ok",
        values: {
            firstname: "",
            lastname: "",
            email: "",
            password: "",
            agbs: false,
            dsgvo: false,
        },
        errors: {},
        autoLogin: false,
    };
    return useState(state);
}
export async function login(state, setState) {
    const { values } = state;
    setState({ ...state, state: "pending", autoLogin: false });
    try {
        const response = await IDP.login({
            username: values.email,
            password: values.password,
        });
        if (response.isSuccess()) {
            setState({
                ...state,
                errors: {},
                state: "success",
            });
            return response.getResult().data;
        }
        else {
            const errors = response.getErrors({
                "body.username": "email",
                "body.password": "password",
            });
            setState({
                ...state,
                state: "ok",
                errors: errors,
            });
        }
    }
    catch (error) {
        console.error(error);
        setState({ ...state, errors: {}, state: "error" });
    }
    return null;
}
export async function register(state, setState) {
    const { values } = state;
    //check agbs && dsgvo
    const errors = {};
    if (!values.agbs)
        errors.agbs = "notSet";
    if (!values.dsgvo)
        errors.dsgvo = "notSet";
    if (errors.dsgvo || errors.agbs) {
        setState({ ...state, state: "ok", errors });
        return false;
    }
    setState({ ...state, state: "pending" });
    try {
        const response = await IDP.register({
            firstname: values.firstname,
            lastname: values.lastname,
            email: values.email,
            password: values.password,
        });
        if (response.isSuccess()) {
            setState({
                ...state,
                errors: {},
                state: "success",
            });
            return true;
        }
        else {
            const errors = response.getErrors({
                "body.secret": "secret",
                "body.firstname": "firstname",
                "body.lastname": "lastname",
                "body.email": "email",
                "body.password": "password",
            });
            setState({
                ...state,
                state: "ok",
                errors: errors,
            });
        }
    }
    catch (error) {
        setState({ ...state, state: "error" });
        console.error(error);
    }
    return false;
}
export async function challengeEmail(state, setState, secret) {
    setState({ ...state, state: "pending" });
    const { values } = state;
    try {
        const response = await IDP.challengeEmail({
            secret,
            email: values.email,
        });
        if (response.isSuccess()) {
            setState({ ...state, errors: {}, state: "success" });
            const session = response.body.data;
            return session;
        }
        else {
            const errors = response.getErrors({
                "body.email": "email",
                "body.secret": "secret",
            });
            setState({
                ...state,
                state: "ok",
                errors: errors,
            });
        }
    }
    catch (error) {
        console.error(error);
        setState({ ...state, state: "error" });
    }
    return null;
}
export async function resetPassword(state, setState) {
    setState({ ...state, state: "pending" });
    const { values } = state;
    try {
        const response = await IDP.resetPassword({
            username: values.email,
        });
        if (response.isSuccess()) {
            setState({ ...state, errors: {}, state: "success" });
            return true;
        }
        else {
            const errors = response.getErrors({
                "body.username": "email",
            });
            setState({
                ...state,
                state: "ok",
                errors: errors,
            });
        }
    }
    catch (error) {
        console.error(error);
        setState({ ...state, state: "error" });
    }
    return false;
}
export async function challengePassword(state, setState, secret) {
    setState({ ...state, state: "pending" });
    const { values } = state;
    try {
        const response = await IDP.challengePassword({
            secret,
            username: values.email,
            password: values.password,
        });
        if (response.isSuccess()) {
            setState({ ...state, errors: {}, state: "success" });
            return true;
        }
        else {
            const errors = response.getErrors({
                "body.password": "password",
                "body.secret": "secret",
            });
            setState({
                ...state,
                state: "ok",
                errors: errors,
            });
        }
    }
    catch (error) {
        console.error(error);
        setState({ ...state, state: "error" });
    }
    return false;
}
